<template>
  <div id="app">
    <header-top></header-top>
    <router-view/>
  </div>
</template>
<script>
import Header from './components/header'
export default {
  components: {
    HeaderTop: Header
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
